import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  QuoteResponse,
  MemberBreakdown,
} from '../../models/quote-response.model';

@Component({
  selector: 'app-quote-details-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './quote-details-modal.component.html',
  styleUrls: ['./quote-details-modal.component.scss'],
})
export class QuoteDetailsModalComponent {
  @Input() quote: QuoteResponse | null = null;
  @Input() isOpen: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  close() {
    this.closeModal.emit();
  }

  getProviderInitials(providerName: string): string {
    const words = providerName.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return providerName.substring(0, 2).toUpperCase();
  }

  getProviderColor(providerName: string): string {
    const colors = [
      'bg-gradient-to-br from-teal-500 to-teal-600',
      'bg-gradient-to-br from-blue-500 to-blue-600',
      'bg-gradient-to-br from-green-500 to-green-600',
      'bg-gradient-to-br from-purple-500 to-purple-600',
      'bg-gradient-to-br from-indigo-500 to-indigo-600',
      'bg-gradient-to-br from-pink-500 to-pink-600',
    ];
    let hash = 0;
    for (let i = 0; i < providerName.length; i++) {
      hash = providerName.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colorIndex = Math.abs(hash % colors.length);
    return colors[colorIndex];
  }

  formatCurrency(amount: number | string | null): string {
    if (amount === null || amount === undefined) return '0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return numAmount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  getInsuranceClassName(classNumber: number): string {
    const classNames: { [key: number]: string } = {
      1: 'VIP',
      2: 'Class A',
      3: 'Class B',
      4: 'Class C',
    };
    return classNames[classNumber] || `Class ${classNumber}`;
  }

  getInsuranceClassColor(classNumber: number): string {
    const classColors: { [key: number]: string } = {
      1: 'bg-purple-100 text-purple-800 border-purple-200',
      2: 'bg-blue-100 text-blue-800 border-blue-200',
      3: 'bg-green-100 text-green-800 border-green-200',
      4: 'bg-gray-100 text-gray-800 border-gray-200',
    };
    return (
      classColors[classNumber] || 'bg-gray-100 text-gray-800 border-gray-200'
    );
  }

  getTotalMembersPremium(): number {
    if (!this.quote?.membersBreakdown) return 0;
    return this.quote.membersBreakdown.reduce((total, member) => {
      return total + parseFloat(member.BreakdownAmount || '0');
    }, 0);
  }
}
